import store from '@/store';

export const actions = {
  setType({ commit }, message) {
    commit('setType', message);
  },
  setTimeLimit({ commit }, message) {
    commit('setTimeLimit', message);
  },
  setTimeVariable({ commit }, message) {
    commit('setTimeVariable', message);
  },
  setAge({ commit }, message) {
    commit('setAge', message);
  },
  setLanguage({ commit }, message) {
    commit('setLanguage', message);
  },
  setSound({ commit }, message) {
    commit('setSound', message);
  },
  addVideo({ commit }, video) {
    const storePlaylist = JSON.parse(store.getters['settings/playlist']);
    const playlist = storePlaylist.length > 0 ? storePlaylist : [];
    playlist.push(video);
    commit('setVideoPlaylist', JSON.stringify(playlist));
  },
  removeVideo({ commit }, video) {
    const storePlaylist = JSON.parse(store.getters['settings/playlist']);
    const newPlaylist = storePlaylist.filter((x) => x.identifier !== video.identifier);
    commit('setVideoPlaylist', JSON.stringify(newPlaylist));
  },
  setVideoIsPaused({ commit }, message) {
    commit('setVideoIsPaused', message);
  },
  setVideoList({ commit }, message) {
    commit('setVideoList', message);
  },
  displayAgeSetting({ commit }, message) {
    commit('displayAgeSetting', message);
  },
  ageSettingFor({commit}, message) {
    commit('ageSettingFor', message);
  },
  setShowExpiration({ commit }, message) {
    commit('setShowExpiration', message);
  },
  setDisplayVideoLoader({ commit }, message) {
    commit('setDisplayVideoLoader', message);
  },
  setDisplayLoader({ commit }, message) {
    commit('setDisplayLoader', message);
  },
  setLoadingCards({ commit }, message) {
    commit('setLoadingCards', message);
  },
  setFocusSettings({ commit }, message) {
    commit('setFocusSettings', message);
  },
  setFocusLiveLink({ commit }, message) {
    commit('setFocusLiveLink', message);
  },
  setFocusSearchLink({ commit }, message) {
    commit('setFocusSearchLink', message);
  },
  setFocusKidjoWorldLink({ commit }, message) {
    commit('setFocusKidjoWorldLink', message);
  },
  setActiveHeaderBarNav({ commit }, message) {
    commit('setActiveHeaderBarNav', message);
  },
  setHideMobileCard({ commit }, message) {
    commit('setHideMobileCard', message);
  },
  setLiveMode({commit}, message) {
    commit('setLiveMode', message);
  },
  setBannerState({commit}, message) {
    commit('setBannerState', message);
  },
  setHeaderBannerState({commit}, message) {
    commit('setHeaderBannerState', message);
  },
  setActiveSettingsCloseBtn({commit}, message) {
    commit('setActiveSettingsCloseBtn', message);
  },
  setNotificationVisibility({commit}, message) {
    commit('setNotificationVisibility', message);
  },
};
